import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetricCard } from '@components/MetricCard';
import { ConversationAnalytics } from '../types';
import { getTrendType } from '../utils/trendUtils';
import { formatTrend } from '../utils/analyticsUtils';

interface ConversationAnalyticsProps {
  analytics: ConversationAnalytics | null;
}

export const ConversationAnalyticsCards: React.FC<ConversationAnalyticsProps> = ({ analytics }) => {
  const { t } = useTranslation();
  if (!analytics) {
    return (
      <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
          {t('analytics.conversationAnalytics')}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[1, 2, 3].map(i => (
            <MetricCard key={i} title={t('common.loading')} value="" loading={true} />
          ))}
        </div>
      </div>
    );
  }

  const metricCards = [
    {
      title: t('analytics.responseTime'),
      value: analytics.response_time.value,
      icon: 'schedule',
      variant: 'info' as const,
      trend: formatTrend(analytics.response_time.trend),
      trendType: getTrendType(analytics.response_time.trend_direction),
    },
    {
      title: t('analytics.avgTurns'),
      value: analytics.avg_turns.value,
      icon: 'repeat',
      variant: 'primary' as const,
      trend: formatTrend(analytics.avg_turns.trend),
      trendType: getTrendType(analytics.avg_turns.trend_direction),
    },
    {
      title: t('analytics.completionRate'),
      value: `${analytics.completion_rate.value}%`,
      icon: 'flag',
      variant: 'success' as const,
      trend: formatTrend(analytics.completion_rate.trend),
      trendType: getTrendType(analytics.completion_rate.trend_direction),
    },
  ];

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
        {t('analytics.conversationAnalytics')}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {metricCards.map((card, index) => (
          <MetricCard
            key={index}
            title={card.title}
            value={card.value}
            icon={card.icon}
            variant={card.variant}
            trend={card.trend}
            trendType={card.trendType}
          />
        ))}
      </div>
    </div>
  );
};
